import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class TopGuardMenu extends Component {
  constructor(){
    super();

    this.state = { redirect: false, loggedIn: false };
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidMount(){
    if(localStorage.getItem('visitapp:token')){
      this.setState({loggedIn: true});
    }
  }

  handleLogout() {
    localStorage.removeItem('token');
    this.setState({redirect: true});
  }

  render(){
    // Redirect with logout
    if(this.state.redirect){
      return (
        <Redirect to="/" />
      );
    }

    return(
      <div className="d-flex justify-content-between">
        <img src="imgs/visitapp_logo_white.png" alt="Logo Visitapp Industrial" className="img-fluid logo" />
        <div className="guard-menu-right">
          <div className="guard-menu d-flex">
            <a href="/chat" alt="" className="">
              <i className="material-icons">chat</i>
            </a>
            <a href="/" className="ml-3" alt="">
              <i className="material-icons">people</i>
            </a>
            <div className="dropdown">
              <a id="dropdownMenu2" className="ml-3 p-relative" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="material-icons">notifications</i>
                <span className="notifications-number p-absolute">+99</span>
              </a>
              <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">
                <button className="dropdown-item d-flex align-item-center text-muted linkable" type="button">
                  <i className="material-icons mr-2">notifications</i> 
                  <span>Mensaje de la notificación para el guardia</span>
                </button>
              </div>
            </div>
            
            <div className="dropdown">
              <a id="dropdownMenu2" className="ml-3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="material-icons">person</i>
              </a>
              <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                <button className="dropdown-item d-flex align-item-center text-muted linkable" type="button" onClick={ () => {this.props.handleOpen('changePasswordVisible')} } >
                  <i className="material-icons mr-2">lock</i> Cambiar contraseña
                </button>
                <a href="/support/tickets" className="dropdown-item d-flex align-item-center text-muted a-link-guard-top-menu">
                  <i className="material-icons mr-2">settings</i> Soporte
                </a>
                <button className="dropdown-item d-flex align-item-center text-muted linkable" type="button" onClick={this.handleLogout}>
                  <i className="material-icons mr-2">settings_power</i>Salir
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TopGuardMenu;



// WEBPACK FOOTER //
// ./src/components/TopGuardMenu.js